import type { NewsItem } from "@/types";

export const news: NewsItem[] = [
  {
    id: "n1",
    title: "《星际彼岸》口碑持续走高，太空史诗如何拍出东方情感",
    publishedAt: "2025-10-12",
    summary: "上映以来，《星际彼岸》凭借壮阔的太空影像与细腻的人物刻画，成为本季度讨论度最高的影片之一。",
    relatedMovieId: "1001",
  },
  {
    id: "n2",
    title: "悬疑剧《雾都迷案》更新过半，层层反转引发全民推理",
    publishedAt: "2025-10-11",
    summary: "随着剧情深入，《雾都迷案》的线索逐渐交织，观众围绕真凶展开热烈讨论，弹幕量刷新同期纪录。",
    relatedMovieId: "2001",
  },
  {
    id: "n3",
    title: "《大地脉动》荣获年度最佳纪录片，四年拍摄历程曝光",
    publishedAt: "2025-10-09",
    summary: "制作团队首次公开拍摄幕后，横跨高原与荒漠的四年，只为记录自然最真实的脉动。",
    relatedMovieId: "4001",
  },
  {
    id: "n4",
    title: "古装奇幻《山海谣》第二季正式官宣，原班人马回归",
    publishedAt: "2025-10-08",
    summary: "官方发布概念海报，宣布《山海谣》第二季已进入制作阶段，原班主演阵容将悉数回归。",
    relatedMovieId: "2002",
  },
  {
    id: "n5",
    title: "《追风者》动作场面获好评，导演谈实拍与安全保障",
    publishedAt: "2025-10-06",
    summary: "影片中多场街头飙车戏份均为实拍，导演在采访中分享了拍摄难点与团队的安全协作。",
    relatedMovieId: "1004",
  },
  {
    id: "n6",
    title: "旅行综艺《快乐星球旅行团》收官，温暖群像收获好评",
    publishedAt: "2025-10-04",
    summary: "节目以真实自然的相处方式打动观众，收官之夜相关话题登上热搜，观众期待下一季。",
    relatedMovieId: "3001",
  },
  {
    id: "n7",
    title: "权谋剧《暗流》口碑发酵，冷静叙事获成年观众认可",
    publishedAt: "2025-10-02",
    summary: "剧集以克制冷静的镜头语言呈现职场博弈，被观众称为“需要静下心来看的好剧”。",
    relatedMovieId: "2004",
  },
  {
    id: "n8",
    title: "《舌尖上的街巷》回归，镜头记录城市烟火与人情",
    publishedAt: "2025-09-29",
    summary: "新一季纪录片走进更多城市街巷，用食物串联起摊主与食客之间真实而温暖的故事。",
    relatedMovieId: "4004",
  },
];